import apiClient from './apiClient';

export class PartGroupsService {

  /**
   * 
   * @summary Get all part groups
   * 
   * @param {{
   *  searchText: string,
   *  sortOrderField: string,
   *  sortDirection: string,
   *  itemsPerPage?: number,
   *  itemsToSkip?: number,
   * }} search 
   * @returns {Promise<{
   *   items: {
   *     ID: number,
   *     Name: string,
   *     WordsToInclude: string,
   *     WordsToExclude: string,
   *     DefaultRefinedMinQty: number,
   *     DefaultQtyCap: number,
   *     DefaultMinQtyToScan: number,
   *     CategoryIDs: string | null,
   *   }[],
   *   totalItemCount: number
   * }>} 
   */
  async getPartGroups(search) {
    const response = await apiClient.getWithCache("api/partGroup/", {
      params: search
    });
    return response.data;
  }
  
  async getPartGroup(id) {
    const response = await apiClient.getWithCache("api/partGroup/" + id);
    return response.data;
  }

  async getPartGroupByName(name) {
    const response = await apiClient.getWithCache("api/partGroup/byName/" + name);
    return response.data;
  }

  async savePartGroup(partGroup) {
    const response = await apiClient.post("api/partGroup", partGroup);
    apiClient.clearCache('api/partGroup');
    return response.data;
  }

  async deletePartGroup(id) {
    const response = await apiClient.delete("api/partGroup/" + id);
    apiClient.clearCache('api/partGroup');
    return response.data;
  }
}
